
import CompanyDescription from 'models/CompanyDescription';

import Component from './component';

export interface Props {
    history: CompanyDescription[];
    title: string;
}

Component.defaultProps = {};
export default Component;